/* eslint-disable no-unused-vars */

export const ApocalypseLowSymbolNames = {
    L1: `L1`,
    L2: `L2`,
    L3: `L3`,
    L4: `L4`,
    L5: `L5`,
} as const;

// eslint-disable-next-line no-redeclare
export type ApocalypseLowSymbolNames =
    (typeof ApocalypseLowSymbolNames)[keyof typeof ApocalypseLowSymbolNames];

export const ApocalypseHighSymbolNames = {
    M1: `M1`,
    M2: `M2`,
    M3: `M3`,
    M4: `M4`,
    M5: `M5`,
} as const;

// eslint-disable-next-line no-redeclare
export type ApocalypseHighSymbolNames =
    (typeof ApocalypseHighSymbolNames)[keyof typeof ApocalypseHighSymbolNames];

export const ApocalypseSpecialSymbolNames = {
    // WILD: `W`,
    // BIG_FISH: `BF`,
    // F1: `F1`,
    // F2: `F2`,
    // F3: `F3`,
    // F4: `F4`,
    // F5: `F5`,
    // F6: `F6`,
    // F7: `F7`,
    // MYSTERY: `M`,
    XNUDGE: `NUDGE`,
    SCATTER: `SCATTER`,
    BLANK: `X`,
    DUMP: `DUMP`,
    WILD: `WILD`,
} as const;

// eslint-disable-next-line no-redeclare
export type ApocalypseSpecialSymbolNames =
    (typeof ApocalypseSpecialSymbolNames)[keyof typeof ApocalypseSpecialSymbolNames];

export const ApocalypseSymbolNames = {
    ...ApocalypseLowSymbolNames,
    ...ApocalypseHighSymbolNames,
    ...ApocalypseSpecialSymbolNames,
} as const;

// eslint-disable-next-line no-redeclare
export type ApocalypseSymbolNames =
    (typeof ApocalypseSymbolNames)[keyof typeof ApocalypseSymbolNames];

// * if wild then full
export enum ApocalypseSymbolSize {
    X033 = 0.33,
    X075 = 0.75,
    X1 = 1,
    X2 = 2,
    X3 = 3,
    X4 = 4,
}

export enum SimpleReelModelState {
    IDLE = `IDLE`,
    START = `START`,
    SPIN = `SPIN`,
    STOP = `STOP`,
    STOPPED = `STOPPED`,
    BOUNCE = `BOUNCE`,
    NUDGE = `NUDGE`,
}

export enum BlockerStates {
    OPEN = `open`,
    CLOSED = `closed`,
}

export enum ScatterStates {
    WIN = `win`,
    LOSE = `lose`,
    NORMAL = `normal`,
    ANTICIPATION = `anticipation`,
}

export enum DisplayObjectNames {
    REELS_CONTAINER = `ReelsContainer`,
}

export enum ApocalypseBackgroundNames {
    CATACLYSM = `cataclysmBackground`,
}
